import { render, staticRenderFns } from "./MapreView.vue?vue&type=template&id=f4f271ac"
import script from "./MapreView.vue?vue&type=script&lang=js"
export * from "./MapreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports